import React, { Component } from "react";
const hiddenFileInput = React.createRef(null);

class ModalReactivacionRegente extends Component {
  render() {
    return (
      <>
        <div>
          <fieldset className="panel">
            <legend> </legend>
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="form-group">
                  <label htmlFor="regente">
                      Regente:{" "}
                      <span className="text-danger"> *</span>
                    </label>
                    <select
                      name="regente_id"
                      id="regente_id"
                      onChange={(e) =>
                        this.props.component.handleRegenteReactivacion(e)
                      }
                      value={this.props.state.regente_id}
                      className="form-control"
                    >
                      <option value="">Seleccione</option>
                      {this.props.state.opciones_regente.map((option) => (
                        <option key={option.id} value={option.id}>
                          {option.nombre} [{option.folio_regente}]
                        </option>
                      ))}
                    </select>
                    <label htmlFor="licencia">
                      licencias:{" "}
                      <span className="text-danger"> *</span>
                    </label>
                    <select
                      name="licencia_id"
                      id="licencia_id"
                      onChange={(e) =>
                        this.props.component.handleLicenciaReactivacion(e)
                      }
                      value={this.props.state.licencia_id}
                      className="form-control"
                    >
                      <option value="">Seleccione</option>
                      {this.props.state.opciones_licencias.map((option) => (
                        <option key={option.id} value={option.id}>
                          {option.folio_licencia}
                        </option>
                      ))}
                    </select>
                    <label htmlFor="sancion">
                      Causa reactivación:{" "}
                      <span className="text-danger"> *</span>
                    </label>{/*
                    <select
                      name="causa_reactivacion"
                      id="causa_reactivacion"
                      onChange={(e) =>
                        this.props.component.handleOnChangeCausaReactivacion(e)
                      }
                      value={this.props.state.causa_reactivacion_id}
                      className="form-control"
                    >
                      <option value="">Seleccione</option>
                      {this.props.state.opciones_causas_reactivacion.map((option) => (
                        <option key={option.id} value={option.id}>
                          {option.descripcion}
                        </option>
                      ))}
                      </select>*/}
                      <textarea
                      className="form-control"
                      placeholder="Causa de la reactivación"
                      maxLength={1000}
                      rows="5"
                      name="causa_reactivacion"
                      value={this.props.state.causa_reactivacion}
                      onChange={(e) =>
                        this.props.component.handleOnChangeCausaReactivacion(e)
                      }
                    ></textarea>
                  </div>
                </div>
                <div className="col-lg-10">
                  <div className="form-group">
                    <label htmlFor="documentp_1">
                      {" "}
                      <span className="text-danger">
                        {" "}
                        Solo se aceptan archivos .pdf *
                      </span>
                    </label>
                    <input
                      name="documento_reactivacion"
                      type="text"
                      disabled={true}
                      //defaultValue="Subir informe inspector"
                      value={this.props.state.nom_documento}
                      className="form-control m-b-5"
                      placeholder="Subir (caja o documento)"
                    ></input>
                  </div>
                </div>
                <div className="col-md-2" style={{ marginTop: "1.7%" }}>
                  <div className="form-group">
                    <button
                      type="button"
                      name="b_documento_reactivacion"
                      className="btn btn-primary float-right"
                      onClick={(e) => hiddenFileInput.current.click()}
                    >
                      Seleccionar archivo
                    </button>
                    <input
                      type="file"
                      accept=".pdf"
                      ref={hiddenFileInput}
                      name="documento_reactivacion"
                      onChange={(e) => this.props.component.handleFile(2, e.target)}
                      style={{ display: "none" }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </fieldset>
          <hr></hr>
          <div className="btn-group float-right">
            <button
              type="button"
              onClick={() => {
                this.props.component.closeModalSancionRegReac(1)
                //this.props.component.limpiarCampos(4,0);
              }}
              className="btn btn-danger"
            >
              Regresar
            </button>
            <button
              type="button"
              onClick={() => {
                this.props.component.handleSubmit(2,4);
              }}
              className="btn btn-primary"
            >
              Aceptar
            </button>
          </div>
        </div>
      </>
    );
  }
}

export default ModalReactivacionRegente;